import { Component, OnInit } from '@angular/core';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { Utente } from 'src/app/models/rbac/Utente';
import { UtenteService } from 'src/app/services/utente.service';
import { NuovoUtenteComponent } from './nuovo-utente/nuovo-utente.component';
import { PasswordComponent } from './password/password.component';

@Component({
  selector: 'app-lista-utenti',
  templateUrl: './lista-utenti.component.html',
  styleUrls: ['./lista-utenti.component.scss']
})
export class ListaUtentiComponent implements OnInit {
  modalRef: MdbModalRef<NuovoUtenteComponent> | null = null;
  modalRef2: MdbModalRef<PasswordComponent> | null = null;

  utenti: Utente[] = []

  constructor(private servUtenti: UtenteService,
    private modalService: MdbModalService) { }

  ngOnInit(): void {
    this.servUtenti.getListaUtenti().subscribe((data: any) => {
      console.log(data)
      this.utenti = data['data'].map((u: any) => {
        let ut = new Utente()
        ut.setUtente(u)
        return ut
      })
    })
  }

  password(id:number){
    console.log(id)
    this.modalRef2 = this.modalService.open(PasswordComponent, {
      modalClass: 'modal-sm',
      data: {
        titolo: 'Modifica Password',
        utente_id: id
      }
    })
    this.modalRef2.onClose.subscribe((pass: string) => {
      console.log(pass);
      let dati = {
        id: id,
        password: pass
      }
      this.servUtenti.modificaPassword(dati).subscribe((data: any) => {
        console.log(data)
      })
    });
  }

  modificaUtente(id: number) {
    console.log(id)
    this.modalRef = this.modalService.open(NuovoUtenteComponent, {
      modalClass: 'modal-lg',
      data: {
        titolo: 'Modifica Utente',
        utente: this.utenti.find(u => u.getID() == id)
      }
    })
    this.modalRef.onClose.subscribe((utente: Utente) => {
      console.log(utente);
      let dati = {
        id: utente.getID(),
        nome: utente.getNome(),
        cognome: utente.getCognome(),
        email: utente.getEmail(),
        ruolo: utente.getIDTipoUt(),
        abilitato: utente.getConfirmed() ? '1' : '0'
      }
      this.servUtenti.modificaUtente(dati).subscribe((data: any) => {
        console.log(data)
      })
    });
  }

  aggiungiUtente() {
    console.log('aggiungi utente')
    this.modalRef = this.modalService.open(NuovoUtenteComponent, {
      modalClass: 'modal-lg',
      data: { titolo: 'Nuovo Utente' }
    })
    this.modalRef.onClose.subscribe((utente: Utente) => {
      console.log(utente);
      let dati = {
        nome: utente.getNome(),
        cognome: utente.getCognome(),
        email: utente.getEmail(),
        ruolo: utente.getIDTipoUt(),
        abilitato: utente.getConfirmed() ? '1' : '0'
      }
      this.servUtenti.creaUtente(dati).subscribe((data: any) => {
        console.log(data)
      })
    });
  }

}
